module.exports = __webpack_public_path__ + "img/bottom-1.262c9378.png";